import "./BtnAcessoRapido.css"

const BtnAcessoRapido = (props) => {
    return(
        <section className="quick-actions">
            <a href={props.link}>
                <button className="outline-btn" id="btnCadastrarLeadsTopo">
                    <span>{props.icone}</span>
                    <span>{props.text}</span>
                </button>
            </a>
        </section>
    );
};

export default BtnAcessoRapido;